module.exports = __webpack_public_path__ + "static/media/rim-front-right.4707d683.jpg";